<template>
  <div>
    <full-loading />
    <dashboard-top-toolbar :drawer.sync="drawer" />
    <dashboard-navigation
      :navigation-items="navigationItems"
      :background="`${bucketUrl}/assets/sidebar_parent.png`"
      :drawer="drawer"
    />
    <main class="main-content" v-if="me">
      <transition
        name="slide-x-transition"
        mode="out-in"
        v-if="me && me.type === 'parent'"
      >
        <router-view></router-view>
      </transition>
    </main>
    <custom-snackbar />
    <dashboard-footer />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import CustomSnackbar from '@/components/snackbar/snackbar'
import DashboardFooter from '@/components/DashboardFooter'
import Auth from '@/modules/auth/models/Auth'
import DashboardNavigation from '@/modules/auth/views/dashboard/DashboardNavigation'
import DashboardTopToolbar from '@/modules/auth/views/dashboard/DashboardTopToolbar'
import FullLoading from '@/modules/auth/views/dashboard/FullLoading'

export default {
  name: 'ParentDashboard',
  components: {
    CustomSnackbar,
    DashboardFooter,
    DashboardNavigation,
    DashboardTopToolbar,
    FullLoading
  },
  computed: {
    ...mapState(['bucketUrl', 'lessonTerm']),
    me() {
      return Auth.query()
        .where('type', 'parent')
        .first()
    },
    navigationItems() {
      return [
        {
          icon: 'dashboard',
          text: 'Dashboard',
          url: '/parent/dashboard/overview'
        },
        {
          icon: 'home',
          text: 'Children',
          url: '/parent/dashboard/children'
        },
        {
          icon: 'book',
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}s`,
          url: '/parent/dashboard/lessons'
        },
        {
          icon: 'help',
          text: 'FAQs',
          url: '/parent/dashboard/support'
        },
        {
          icon: 'settings',
          text: 'Account details',
          url: '/parent/dashboard/account'
        }
      ]
    }
  },
  data() {
    return {
      username: '',
      drawer: this.$vuetify.breakpoint.lgAndUp
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar'])
  },
  async created() {
    try {
      await Auth.dispatch('me', 'parents')
    } catch (error) {
      this.$router.push('/parent/login')
      if (error.status === 401) {
        this.showErrorSnackbar(
          'You need to log in as a parent to access the dashboard'
        )
      }
    }
  }
}
</script>
